import React, { useState, useCallback } from "react";
import GapPacketFormFields from "./GapPacketFormFields";
import { useDispatch } from "react-redux";
import { useForm } from "react-hook-form";
import { withStyles } from "material-ui";
import styles from "../styles/GapPacketStyles";
import { filterHomePageGrid, refreshGrid } from "spark-grid";

export const FORM_NAME = "gapPacketForm";

const GapPacketForm = ({ gridName }) => {
	const [toggle, setToggle] = useState(false);
	const dispatch = useDispatch();

	const { handleSubmit, control, reset, setValue } = useForm({
		defaultValues: { status: "Pending" }
	});

	const onClear = useCallback(() => {
		setToggle((t) => !t);
		reset({ status: "Pending" });
		dispatch(refreshGrid(gridName));
		dispatch(filterHomePageGrid(gridName, { status: "Pending" }));
	}, [dispatch, gridName, reset]);

	const onSubmit = useCallback(
		(values) => {
			dispatch(filterHomePageGrid(gridName, values));
		},
		[dispatch, gridName]
	);

	const handleSubmitClick = useCallback(() => {
		handleSubmit(onSubmit)();
	}, [handleSubmit, onSubmit]);

	return (
		<form onSubmit={handleSubmit(onSubmit)}>
			{toggle && (
				<GapPacketFormFields
					control={control}
					setValue={setValue}
					clear={onClear}
					submit={handleSubmitClick}
				/>
			)}
			{!toggle && (
				<GapPacketFormFields
					control={control}
					setValue={setValue}
					clear={onClear}
					submit={handleSubmitClick}
				/>
			)}
		</form>
	);
};

export default withStyles(styles)(GapPacketForm);
